
















































import {Component, Vue} from 'vue-property-decorator';
import SettingsIcon from '@/components/icons/SettingsIcon.vue';
import SyncIcon from '@/components/icons/SyncIcon.vue';
import LogoutIcon from '@/components/icons/LogoutIcon.vue';
import {Action} from '@/store';
import User from '@/api/user';
import {BusEvent} from '@/models/bus';

@Component({
    components: {
        'logout-icon': LogoutIcon,
        'sync-icon': SyncIcon,
        'settings-icon': SettingsIcon,
    },
})
export default class Header extends Vue {
    public user: User|null = null;
    public error: boolean = false;


    public beforeMount() {
        this.error = false;

        // noinspection JSIgnoredPromiseFromCall
        this.loadClient();
    }

    public async loadClient(): Promise<void>  {
        try {
            this.user = await User.get();
        }
        catch (e) {
            this.error = true;
            this.$bus.$emit(BusEvent.ERROR, 'Could not get user information', e);
        }
    }

     public async logout(): Promise<void> {
        await this.$store.dispatch(
            Action.LOGOUT,
            {
                sender: this,
            }
        );
        this.$router.push('/');
    }
}
